import { styled } from '@mui/material/styles';
import { Box, IconButton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { createColorFilteredComponent, createPrefixedPropsFilteredComponent } from 'helpers/styledHelpers';

export const StyledTableContainer = styled(Box)({
  width: '100%',
});

export const StyledLoadingContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50vh',
});

export const StyledRewardContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const StyledStarIcon = createColorFilteredComponent<{ $color: string }>(StarIcon)(({ $color }) => ({
  color: $color
})); 

export const StyledTableHeader = createPrefixedPropsFilteredComponent<{ $textAlign: string; $width?: number }>('th')(({ $textAlign, $width }) => ({
  textAlign: $textAlign,
  overflow: 'hidden',
  ...($width ? { width: $width, minWidth: $width, maxWidth: $width } : {}),
}));

export const StyledIconButton = styled(IconButton)({
  marginRight: '0.25rem',
});

export const StyledToolbarContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const StyledTruncatedText = createPrefixedPropsFilteredComponent<{ $textAlign: string; $ml?: string }>('span')(({ $textAlign, $ml }) => ({
  display: 'block',
  width: '100%',
  marginLeft: $ml,
  textAlign: $textAlign,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}));